import { Module, ActionContext } from 'vuex'
import { RootState, BasicLocationState } from '../types'
import { RouteLocationNormalized } from 'vue-router'
import { Sdk } from '@/sdk/sdk'
import { getLocation } from '@/services/home.service'
import { getApiLang } from '@/i18n/resolveLanguage'

const screensaver: Module<BasicLocationState, RootState> = {
  state: {
    currentConditions: undefined,
    location: undefined,
  },
  mutations: {
    setLocationData(state, data: Partial<BasicLocationState>) {
      Object.assign(state, data)
    },
  },
  actions: {
    async fetchLocationData(
      { commit }: ActionContext<BasicLocationState, RootState>,
      p: RouteLocationNormalized | undefined,
    ) {
      const isMock = p?.query?.mock === 'true'
      const sdk = new Sdk(isMock, getApiLang())
      try {
        const location = await getLocation(sdk, p?.query)
        const locationKey = location?.Key
        const data = {
          currentConditions: await sdk.getCurrentConditions(locationKey),
          location: location,
        }
        commit('setLocationData', data)
        return data
      } catch (error) {
        console.error('Error getting home data:', error)
        return Promise.reject(error)
      }
    },
  },
}

export default screensaver
